import React from 'react';
import { Lock } from 'lucide-react';

const AdventCalendar: React.FC = () => {
  // Generate days 4 to 25
  const days = Array.from({ length: 22 }, (_, i) => i + 4);

  return (
    <>
      <div className="w-full max-w-6xl mx-auto px-4 pb-20">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 md:gap-8">
          {days.map((day) => {
            const isDay4 = day === 4;
            const isRed = day % 2 === 0;
            
            // Styles for closed doors
            const doorColorClass = isRed ? 'wood-texture-red' : 'wood-texture';
            const borderColorClass = isRed ? 'border-red-900' : 'border-green-900';
            const textColorClass = isRed ? 'text-red-950' : 'text-green-950';

            return (
              <div 
                key={day}
                className={`
                  relative h-40 md:h-48 w-full [perspective:1000px] group select-none cursor-default
                `}
              >
                {/* INTERIOR (Visible when door is open) */}
                <div className={`
                  absolute inset-0 rounded-xl flex flex-col items-center justify-center overflow-hidden
                  ${isDay4 
                    ? 'bg-black border-2 border-christmas-gold shadow-[0_0_30px_rgba(248,178,41,0.6)]' 
                    : 'bg-zinc-900 border border-zinc-800 shadow-inner'
                  }
                `}>
                  {isDay4 ? (
                    <>
                      <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(248,178,41,0.2)_0%,rgba(0,0,0,1)_100%)] z-0"></div>
                      <div className="relative z-10 text-center flex flex-col items-center p-2 w-full">
                         <h3 className="font-festive text-2xl md:text-3xl text-christmas-gold drop-shadow-[0_0_10px_rgba(248,178,41,0.8)] leading-none mb-2">
                          PUMP.FUN
                        </h3>
                        <div className="flex flex-col items-center gap-1">
                             <span className="text-white/90 text-[10px] md:text-xs font-bold tracking-widest uppercase">
                                LIVE STREAM
                             </span>
                             <div className="bg-red-600 text-white text-[10px] font-black px-3 py-1 rounded animate-[pulse_1.5s_infinite] border border-red-400 shadow-[0_0_15px_rgba(220,38,38,0.6)] tracking-wider">
                              STARTED
                            </div>
                        </div>
                      </div>
                      
                      {/* Floating Particles */}
                      <div className="absolute inset-0 pointer-events-none">
                        <div className="absolute top-1/4 left-1/4 w-1 h-1 bg-christmas-gold rounded-full animate-ping"></div>
                        <div className="absolute top-3/4 right-1/4 w-1 h-1 bg-christmas-gold rounded-full animate-ping delay-300"></div>
                        <div className="absolute bottom-1/4 left-1/2 w-0.5 h-0.5 bg-white rounded-full animate-pulse"></div>
                      </div>
                    </>
                  ) : (
                    <div className="flex flex-col items-center text-zinc-700">
                      <Lock size={24} className="mb-2 opacity-50" />
                      <span className="text-xs font-mono uppercase tracking-widest">Locked</span>
                    </div>
                  )}
                </div>

                {/* EXTERIOR (The Door Flap) */}
                {/* We only render the door flap for days that are NOT 4 (since 4 is permanently open) */}
                {!isDay4 && (
                  <div className={`
                    absolute inset-0 rounded-xl transition-all duration-700 transform origin-left
                    ${doorColorClass} ${borderColorClass} border-4
                    flex flex-col items-center justify-center
                    shadow-lg
                  `}>
                    {/* Wreath Decoration on some doors */}
                    {day % 3 === 0 && (
                      <div className="absolute top-4 w-12 h-12 rounded-full border-4 border-green-800 bg-green-700/50 flex items-center justify-center shadow-sm">
                        <div className="w-2 h-2 bg-red-600 rounded-full absolute top-0"></div>
                        <div className="w-2 h-2 bg-red-600 rounded-full absolute bottom-1 left-1"></div>
                        <div className="w-2 h-2 bg-red-600 rounded-full absolute bottom-1 right-1"></div>
                      </div>
                    )}

                    <span className={`
                      font-festive text-5xl md:text-6xl drop-shadow-md relative z-10
                      ${textColorClass}
                    `}>
                      {day}
                    </span>
                    
                    {/* Door Knob */}
                    <div className="absolute right-4 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-yellow-600 shadow-sm border border-yellow-800"></div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default AdventCalendar;